export default {
  myBalance: 'Meu saldo',
  topUp: 'Recarga',
  pay: 'Recarga',
  repayment: 'Reembolso',
  balance: 'Saldo',
  usableBalance: 'Saldo disponível',
  inputBalance: 'Por favor, insira o valor',
  payBalance: 'Valor da recarga',
  pecenter: 'Centro pessoal',
  lang: 'Idioma',
  cart: 'Carrinho',
  recipientName: 'Destinatário',
  phone: 'Telefone',
  region: 'Região',
  address: 'Endereço detalhado',
  country: 'País',
  province: 'Província',
  city: 'Cidade',
  postcode: 'CEP',
  action: 'Operação',
  mobileSettings: 'Configurações móveis',
  name: 'Nome',
  debt: 'Dívida',
  add: 'Adicionar endereço de fatura do cartão de crédito',
  addSuccess: 'Adicionado com sucesso',
  editSuccess: 'Modificado com sucesso',
  editBtn: 'Editar',
  edit: 'Modificar endereço de fatura do cartão de crédito',
  del: 'Excluir',
  setDefault: 'Definir como padrão',
  defaultAddress: 'Endereço padrão',
  setDefaultAddress: 'Definir como endereço de entrega padrão',
  setSuccess: 'Definido com sucesso',
  myAddress: 'Meus endereços',
  addAddress: 'Adicionar novo endereço',
  tradeTime: 'Hora da transação',
  type: 'Tipo',
  incomeOrExpend: 'Receita/Despesa',
  accountBalance: 'Saldo da conta',
  tradeNo: 'Número da transação',
  remark: 'Observações',
  tag: 'Etiqueta de endereço',
  addBillAddress: 'Adicionar endereço de fatura',
  deleteBillAddress: 'Excluir endereço de fatura',
  editBillAddress: 'Modificar endereço de fatura',
  mergePay: 'Pagamento combinado',
  username: 'Nome de usuário',
  gender: 'Gênero',
  birthday: 'Aniversário',
  avatar: 'Avatar',
  email: 'E-mail',
  site: 'Localização',
  myOrder: 'Meus pedidos',
  goRecharge: 'Ir para recarga',
  sideBar: {
    myAccount: 'Minha conta',
    addressManage: 'Gerenciamento de endereços',
    myAsset: 'Meus ativos',
    billAddress: 'Endereço de fatura',
  },
  addDoorNoTips: 'Por favor, adicione o número da porta no endereço de entrega',
  holder: {
    receiver: 'Destinatário',
    firstName: 'Sobrenome',
    name: 'Nome',
    region: 'Por favor, selecione província/cidade/distrito/rua',
    address:
      'Por favor, insira informações detalhadas do endereço, como rua, número da porta, bairro, número do prédio, unidade, etc.',
    phone: 'Número de telefone ou celular deve ser preenchido',
    input: 'Por favor, insira',
    select: 'Por favor, selecione',
    tagHolder: 'Máximo de 120 caracteres (opcional)',
    postCodeNoMatch: 'CEP não corresponde à região',
    doorNo: 'Número da porta',
  },
  forget: {
    accountSafe: 'Segurança da conta',
    setPwd: 'Modificar senha',
    inputBindEmail: 'Por favor, insira o e-mail vinculado',
    inputVerifyCode: 'Por favor, insira o código de verificação',
    inputPwd: 'Por favor, insira a nova senha',
  },
  accountInfo: {
    name: 'Informações da conta',
    selfInfo: 'Informações pessoais',
    cardBillAddress: 'Endereço de fatura do cartão de crédito',
    shipAddress: 'Endereço de entrega',
    editUser: 'Modificar informações do usuário',
    inputCountry: 'Por favor, insira seu país',
    editEmail: 'Modificar e-mail',
    editEmailHint:
      '（Recomendado modificar apenas quando o e-mail estiver configurado incorretamente ou houver problemas）',
    editEmailHint1:
      'Para a segurança da sua conta, é necessário primeiro fazer verificação de segurança através de "código de verificação de e-mail + senha de login"',
    editEmailHint2:
      'Para a segurança da sua conta, é necessário primeiro fazer verificação de segurança através de "código de verificação de e-mail"',
    currentEmail: 'E-mail atual',
    clickVerify: 'Enviar',
    reGet: 'Obter novamente',
    nextStep: 'Próximo passo',
    notReGetCode: ' depois obter novamente',
    logoutAccount: 'Cancelar conta',
    emailNotEmpty: 'E-mail não pode estar vazio',
    logoutReason: 'Por favor, selecione o motivo do cancelamento',
    latelyLogin: 'Login recente',
    moreRecord: 'Mais registros',
    visitRecord: 'Registro de visitas',
    visitTime: 'Hora da visita',
    ipAndDevice: 'Endereço IP e tipo de dispositivo',
    editLoginPwdHint:
      'Uma senha com alta segurança pode tornar a conta mais segura. Recomendamos que você altere a senha regularmente e defina uma senha que contenha números e letras e tenha mais de 6 caracteres.',
    editPayPwdHint:
      'Senha necessária ao usar o saldo acbuy para pagamento, defina uma senha de pagamento para garantir a segurança do pagamento.',
    editVerifyEmailHint: 'Para proteger a segurança da sua conta, por favor, verifique seu e-mail.',
    payPwd: 'Senha de pagamento',
    editPayPwd: 'Modificar senha de pagamento',
    setPayPwd: 'Definir senha de pagamento',
    deleteAccount: 'Excluir conta',
  },
  logoutReasonEnum: {
    0: 'Problemas de segurança/privacidade',
    1: 'Mau atendimento ao cliente',
    2: 'Taxas muito altas',
    3: 'Processo de compra complexo',
    4: 'Outros motivos',
  },
  tradeTypeEnum: {
    0: 'Receita',
    1: 'Despesa',
  },
  asset: {
    currentBalance: 'Saldo atual',
    canWithdrawBalance: 'Valor disponível para saque',
    withdraw: 'Saque',
    serialNo: 'Número de série',
    amount: 'Valor',
    lossAmount: 'Valor gasto',
    withdrawAmount: 'Valor do saque',
    inputWithdrawAmount: 'Por favor, insira o valor do saque',
    withdrawSuccess: 'Saque enviado, o tempo de processamento pode levar 72 horas.',
    transactionDate: 'Data da transação',
    withdrawMethod: 'Método de saque',
    availableAmount: 'Valor disponível',
    transactionNo: 'Número da transação',
    withdrawMsg:
      'Atenção: O saque do saldo será reembolsado através do canal original. O saldo será reembolsado para a conta de pagamento da transação de saque de acordo com o registro de despesas históricas.',
    transactionRecordsText: 'Registro de transações de valor disponível',
    withdrawRecordText: 'Registro de saque',
  },
  package: {
    packageInfo: 'Informações do pacote',
    weightHaveUnit: 'Peso (gramas)',
    sizeHaveUnit: 'Dimensões (centímetros)',
    freight: 'Frete',
    fee: 'Taxa de entrega',
    transportMode: 'Método de entrega',
    allPackage: 'Todos os pacotes',
    myPackage: 'Meus pacotes',
  },
  packageStatusEnum: {
    0: 'Aguardando pagamento adicional',
    1: 'Aguardando pagamento',
    2: 'Em transporte',
    3: 'Concluído',
    4: 'Cancelado',
  },
  storage: {
    name: 'Armazém',
    warehouseTime: 'Hora de armazenamento',
    submitTransport: 'Enviar entrega',
    lineCanUse: 'Número de peças disponíveis',
    commonImg: 'Fotos de inspeção de qualidade',
    customPhoto: 'Fotos personalizadas',
    extendCare: 'Estender armazenamento',
    extendHint: 'Seus produtos serão estendidos no armazém por (30*N) dias, o tempo de expiração é',
    packMode: 'Método de embalagem',
    retainPack: 'Manter embalagem',
    normalPack: 'Embalagem padrão',
    normalPackHint: 'Os produtos usarão a embalagem original para empacotamento.',
    foldPack: 'Embalagem dobrável',
    foldPackHint:
      'Para caixas de papelão não fixadas com cola, o armazém as desmontará, dobrará e achatará antes de colocá-las no seu pacote, o que pode reduzir o volume do pacote até certo ponto. Mas também pode haver casos em que o volume do pacote aumenta (quando há poucos produtos, o comprimento e largura da caixa dobrada podem aumentar).',
    discardPack: 'Descartar embalagem',
    discardPackHint:
      'Após descartar a embalagem, o vendedor pode não aceitar qualquer serviço pós-venda, e a embalagem não pode ser recuperada/readicionada.',
    photoTemplate: 'Modelo de foto',
  },
  operate: 'Operação',
  editAddress: 'Editar endereço',
  underPaid: 'Aguardando pagamento',
  goTopay: 'Ir pagar',
  viewRecord: 'Ver registro',
  faq: 'Perguntas frequentes',
  question1: 'P: Se eu enviar uma solicitação de saque, minha conta será congelada?',
  response1:
    'R: Após solicitar o saque, a conta congelará o valor da solicitação para garantir que o valor do reembolso seja consistente com o valor que você solicitou',
  question2: 'P: "Concluído" no registro de saque significa que o saque foi bem-sucedido?',
  response2:
    'R: "Concluído" significa que o acbuy já organizou o reembolso, mas o tempo necessário para chegar à sua conta original depende do tempo de processamento da plataforma terceirizada.',
  question3: 'P: O saque é baseado na taxa de câmbio em tempo real?',
  response3:
    'R: Não, a taxa de câmbio do saque é baseada na taxa de câmbio no momento da recarga dos fundos.',
  question4: 'P: Como fazer saque quando o saldo da conta é diferente do valor do saque?',
  response4:
    'R: Quando o saldo da conta for maior que o valor disponível para saque, você pode solicitar várias vezes até que o saldo da conta seja 0. Quando o saldo da conta for menor que o valor disponível para saque, você pode solicitar um saque total de uma vez.',
  stillRecharge: 'Saldo insuficiente para pagar o pedido, ainda precisa recarregar',
  amountDue: 'Valor a pagar',
  handingFee: 'Taxa de serviço',
  coupon: 'Cupom',
  couponPlaceholder: 'Usar código de cupom para trocar cupom',
  off: 'Desconto',
  minFee: 'Taxa mínima',
  freightText: 'Frete',
  limitTo: 'Limite',
  shippingUsage: 'Uso de transporte',
  availableWarehouse: 'Armazém disponível',
  shippingFeeText: 'Frete (não inclui taxa de liberação alfandegária)',
  internationalParcel: 'Pacote internacional',
  to: 'Para',
  availableCoupons: 'Cupons disponíveis',
  usedCoupons: 'Cupons usados',
  expiredCoupons: 'Cupons expirados',
  exchangeSuccess: 'Troca bem-sucedida!',
  myAffiliate: {
    name: 'Distribuição',
  },
  affiliateShare: 'Compartilhar',
  copyText: 'Copiar',
  affiliateShareMsg:
    'O pagamento de frete através do link compartilhado trará receita de comissão para você.',
  businessType: 'Tipo de negócio',
  payWay: 'Tipo de transação',
  bzOrderNo: 'Número AC',
  amountDueTooltip:
    'Devido à conversão de taxa de câmbio entre moedas, pode haver uma diferença de aproximadamente 0,01 ou 0,02',
  balanceStatement: 'Extrato de saldo',
  billFlow: 'Extrato de fatura',
  affiliateFavorite: 'Favorito',
  favourite: 'Favorito',
  canUseCountry: 'País disponível',
  commonNo: 'Número',
  question5: 'P: Quanto tempo leva para o saque chegar?',
  response5:
    'R: De acordo com o canal de pagamento e banco, o tempo de saque terá certas diferenças, geralmente de 2 a 25 dias. Normalmente, o saque será reembolsado ao canal que você recarregou ou pagou dentro de 48 horas. Se não receber o saque dentro de 48 horas, pode entrar em contato com o atendimento ao cliente para verificar o status atual do saque.',
}
